import type { ReactNode } from "react";
import { Button } from "@circle-react-uikit/Button";

interface PlusBannerButtonProps {
  children: ReactNode;
}

function PlusBannerButton({ children }: PlusBannerButtonProps) {
  return (
    <Button small variant="secondary-light" className="mt-4 font-medium">
      {children}
    </Button>
  );
}

export default PlusBannerButton;
